/**
 * Bloco de linhas de LEITURA — rótulo à esquerda, valor à direita.
 *
 * Existe porque `Lista` é navegação: cada linha dela é um botão e termina em
 * chevron. Média de glicemia, macros de uma refeição, tempo no alvo — nada
 * disso leva a tela nenhuma, e um chevron ali promete um toque que não
 * acontece. Prometer toque a quem mexe pouco em celular é pior que não
 * oferecer nada.
 *
 * Sem alvo de toque, então sem altura mínima de alvo: a altura é a do texto.
 * `cor` existe só para o semáforo glicêmico, o único lugar do app onde a cor
 * carrega significado.
 */
export type ItemDados = {
  rotulo: string;
  valor: string;
  /** Só para o semáforo: var(--sem-verde) e companhia. */
  cor?: string;
};

export function Dados({ itens }: { itens: ItemDados[] }) {
  return (
    <div style={{ paddingLeft: "var(--gutter)", paddingRight: "var(--gutter)" }}>
      <div className="overflow-hidden cartao">
        {itens.map((it, i) => (
          <div
            key={`${i}-${it.rotulo}`}
            className={`flex items-baseline justify-between gap-4 px-5 py-4 ${
              i > 0 ? "border-t border-border" : ""
            }`}
          >
            <span style={{ fontSize: "var(--t-corpo)", color: "var(--tinta-apoio)" }}>
              {it.rotulo}
            </span>
            <span
              className="font-bold tabular-nums"
              style={{ fontSize: "var(--t-linha)", color: it.cor ?? "var(--tinta)" }}
            >
              {it.valor}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
